import { default as details } from './details';
import { default as addressDetails } from './addressDetails';
import obfuscation from './obfuscation';

export const insurant = {
  ...details,
  ...addressDetails,
  ...obfuscation,
};
